import { render, staticRenderFns } from "./upload_image.vue?vue&type=template&id=106be353&scoped=true&"
import script from "./upload_image.vue?vue&type=script&lang=js&"
export * from "./upload_image.vue?vue&type=script&lang=js&"
import style0 from "./upload_image.vue?vue&type=style&index=0&id=106be353&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106be353",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106be353')) {
      api.createRecord('106be353', component.options)
    } else {
      api.reload('106be353', component.options)
    }
    module.hot.accept("./upload_image.vue?vue&type=template&id=106be353&scoped=true&", function () {
      api.rerender('106be353', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/commodity_management/components/upload_image.vue"
export default component.exports